<div class="modal-header">
	<h4 class="modal-title pull-left"> {{ isEdit ? 'Edit Franchise': 'New Franchise' }} </h4>
	<div aria-label="Close" (click)="onCancel()" class="close pull-right">
		<span aria-hidden="true">×</span>
	</div>
</div>

<div class="modal-body">
	<crm-alert #alert></crm-alert>
	<form name="form" #f="ngForm">
		<div class="form-group">
			<label class="rbv-label">Name</label>
			<input type="text" maxlength="150" name="NAME" [(ngModel)]="franchise.NAME" #NAME="ngModel"
				class="rbv-field form-control rounded-0" [ngClass]="{ 'is-invalid': f.submitted && NAME.invalid }"
				required>
			<div *ngIf="f.submitted && NAME.invalid" class="invalid-feedback">
				<div *ngIf="NAME.errors.required">Name is required</div>
			</div>

			<div class="mt-4">
				<label class="rbv-label">Company History and Initial Franchise Fee </label>
				<quill-editor name="COMPANY_HISTORY" [(ngModel)]="franchise.COMPANY_HISTORY" [modules]="quillModules"
					placeholder=" Enter The Company History and Initial Franchise Fee "></quill-editor>
			</div>

			<div class="mt-4">
				<label class="rbv-label">Royalty Fees</label>
				<quill-editor name="ROYALTY_FEES" [(ngModel)]="franchise.ROYALTY_FEES" [modules]="quillModules"
					placeholder="Enter The Royality Fees"></quill-editor>
			</div>

			<div class="mt-4">
				<label class="rbv-label">Marketing and Advertising Fees</label>
				<quill-editor name="MARKETING_FEES" [(ngModel)]="franchise.MARKETING_ADVERTISING_FEES"
					[modules]="quillModules" placeholder="Enter The Marketing And Adversting Fees"></quill-editor>
			</div>

			<div class="mt-4">
				<label class="rbv-label">Length of Franchise Term</label>
				<quill-editor name="LENGTH_OF_FRANCHISE_TEARM" [(ngModel)]="franchise.FRANCHISE_TERM_LENGTH"
					[modules]="quillModules" placeholder="Enter The Length of Franchise Term"></quill-editor>
			</div>

			<div class="mt-4">
				<label class="rbv-label">Competition</label>
				<quill-editor name="COMPETITION" [(ngModel)]="franchise.COMPETITION" [modules]="quillModules"
					placeholder="Competition"></quill-editor>
			</div>
		</div>

	</form>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
	<button [disabled]="!f.form.valid || isLoading" type="button" class="btn btn-rbv" (click)="onSubmit()">
		<span class="loading-icon-small" *ngIf="isLoading"></span>
		{{isLoading ? 'Saving' : 'Save'}}
	</button>
</div>
